module.exports = __webpack_public_path__ + "img/pic3.e79304dc.jpg";